/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCirclesRelation = createReactComponent("circles-relation", "IconCirclesRelation", [
  ["path", { d: "M9.183 6.117a6 6 0 1 0 4.511 3.986", key: "svg-0" }],
  ["path", { d: "M14.813 17.883a6 6 0 1 0 -4.496 -3.954", key: "svg-1" }]
]);

export { IconCirclesRelation as default };
//# sourceMappingURL=IconCirclesRelation.js.map
